
export const BUBBLE_CATEGORIES = {
    SPEECH: 'speech',
    THOUGHT: 'thought',
    SHOUT: 'shout',
    CAPTION: 'caption'
};

export const BUBBLE_LIBRARY = [
    {
        id: 'oval_classic',
        name: 'Classic Oval',
        category: BUBBLE_CATEGORIES.SPEECH,
        // Normalized 0-100 path. Center approx 50,50. 
        // M 50 5 ...
        path: "M50,5 C75,5 95,25 95,50 C95,75 75,95 50,95 C25,95 5,75 5,50 C5,25 25,5 50,5 Z",
        hasTail: true
    },
    {
        id: 'rect_rounded',
        name: 'Rounded Box',
        category: BUBBLE_CATEGORIES.SPEECH,
        path: "M10,10 L90,10 A10,10 0 0 1 100,20 L100,80 A10,10 0 0 1 90,90 L10,90 A10,10 0 0 1 0,80 L0,20 A10,10 0 0 1 10,10 Z",
        hasTail: true
    },
    {
        id: 'thought_cloud',
        name: 'Thought Cloud',
        category: BUBBLE_CATEGORIES.THOUGHT,
        // Simplified cloud path
        path: "M25,40 Q10,30 20,20 Q30,5 50,15 Q70,5 80,20 Q95,30 80,50 Q90,70 70,80 Q50,95 30,80 Q10,70 25,40 Z",
        hasTail: true // Though thought bubbles have chain tails, we manage tail *type* in renderer or keep it simple.
    },
    {
        id: 'shout_jagged',
        name: 'Shout / Scream',
        category: BUBBLE_CATEGORIES.SHOUT,
        // Spiky path
        path: "M50,5 L60,25 L80,15 L75,35 L95,45 L75,55 L90,75 L65,70 L50,95 L35,70 L10,75 L25,55 L5,45 L25,35 L20,15 L40,25 Z",
        hasTail: true
    },
    {
        id: 'caption_box',
        name: 'Caption Box',
        category: BUBBLE_CATEGORIES.CAPTION,
        path: "M0,0 L100,0 L100,100 L0,100 Z",
        hasTail: false
    }
];
